import { render } from "./ProductGrant.vue?vue&type=template&id=2d6a8c73&scoped=true"
import script from "./ProductGrant.vue?vue&type=script&lang=js"
export * from "./ProductGrant.vue?vue&type=script&lang=js"

import "./ProductGrant.vue?vue&type=style&index=0&id=2d6a8c73&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6a8c73"]])

export default __exports__